import Component from './newsletter.vue';
Vue.component(Component.name, Component);